import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Apollo } from 'apollo-angular';
import { NotificationService } from 'src/app/services/notification.service';
import { ResponseCodeService } from 'src/app/services/response-code.service';
import { AppState } from 'src/app/store/reducers';
import { map, switchMap } from 'rxjs';
import * as fromActions from "./instution-function.actions";
import * as fromGraphql from "./instution-function.graphql"




@Injectable()
export class InstutionFunctionEffects {

  createInstitutionFunction = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createInstitutionFunction),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_INSTUTION_FUNCTION,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertInstutionFunction({ instutionFunction: result?.data }));
              this.notificationService.successMessage('Created Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateInstitutionFunction$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateInstitutionFunction),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_INSTUTION_FUNCTION,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertInstutionFunction({ instutionFunction: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  removeInstutionFunction$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeInstutionFunction),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_INSTUTION_FUNCTION,
        variables: {
          functionUniqueId: action?.functionUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteInstutionFunction({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getAllFunctions$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllFunctions),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_INSTUTIONAL_FUNCTION,
        fetchPolicy: 'network-only',
        variables: {
          instituteUniqueId: action?.instituteUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadInstutionFunctions({ instutionFunctions: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
